import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { deleteProduct } from "../../../../api/Products";

const ProductTable = ({ products = [] }) => {

  const navigate = useNavigate();
  const handleRemoveData = async (id) => {
    const res = await deleteProduct(id);
    if (res.message === "Deleted Successfully") navigate(0);
  };

  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-full">
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              Product name
            </th>

            <th scope="col" className="px-6 py-3">
              Action
            </th>
          </tr>
        </thead>
        {products.length > 0 && (
          <tbody>
            {/* Sample row */}
            {products.map((product, index) => (
              <tr key={index} className="bg-white border-b hover:bg-gray-50">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                >
                  {product.name}
                </th>
                <td className="flex items-center px-6 py-4">
                  <Link
                    to={`/dashboard/main/product/editproduct/${product._id}`}
                    className="font-medium text-blue-600 hover:underline"
                  >
                    Edit
                  </Link>

                  <a
                    href="#"
                    className="font-medium text-red-600 hover:underline ms-3"
                    onClick={() => {
                      handleRemoveData(product._id);
                    }}
                  >
                    Remove
                  </a>
                </td>
              </tr>
            ))}
            {/* Add more rows as needed */}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default ProductTable;
